﻿import {isNullOrEmpty, StringNamedValue} from "@2d-front-monorepo/core";
import React, {JSX, useMemo} from "react";
import {HtmlRequiredControlProps} from "./HtmlControlProps";
import LabeledControl from "./LabeledControl";
import {useLabeledControl} from "./LabeledControlData";

export type SelectProps = HtmlRequiredControlProps<HTMLSelectElement> & {
	items: StringNamedValue[];
	placeholder?: string;
};

export default function Select(props: SelectProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,

		required,
		hint,
		error,

		items,
		placeholder
	} = props;

	const {componentId, ariaRef} = useLabeledControl(id);
	const itemsWithPlaceholder = useMemo(() => {
		if (isNullOrEmpty(placeholder)) {
			return items;
		}

		return [{label: placeholder, value: ""}, ...items];
	}, [items, placeholder])

	if (hidden) {
		return <></>;
	}

	return (
		<LabeledControl label={label} type="select" id={componentId} required={required} column={column} error={error}
		                hint={hint} hidden={hidden} ariaRef={ariaRef}>
			<select
				ref={ref}
				id={componentId}
				onChange={onChange}
				onBlur={onBlur}
				name={name}
				value={value}
				required={required}
				aria-describedby={ariaRef.current?.describedBy}
				aria-invalid={ariaRef.current?.invalid}
				aria-required={required}
				disabled={disabled}
				tabIndex={disabled ? -1 : undefined}>
				{itemsWithPlaceholder.map((item, i) => <option key={i} value={item.value}>{item.label}</option>)}
			</select>
		</LabeledControl>
	);
};
